__turbopack_context__.v({
  "catListContainer": "Q7_Kza_catListContainer",
  "categorySelectBtn": "Q7_Kza_categorySelectBtn",
  "categorySelectBtnActive": "Q7_Kza_categorySelectBtnActive",
  "nextCategoryBtnStyles": "Q7_Kza_nextCategoryBtnStyles",
  "precCategoryBtnStyles": "Q7_Kza_precCategoryBtnStyles",
  "tagListContainerInner": "Q7_Kza_tagListContainerInner",
});
